/*! skrollr 0.6.26 (2014-06-08) | Alexander Prinzhorn - https://github.com/Prinzhorn/skrollr | Free to use under terms of MIT license */
(function (e, t, r) {
  function n(r) {
    if (
      ((o = t.documentElement),
      (a = t.body),
      K(),
      (it = this),
      (r = r || {}),
      (ut = r.constants || {}),
      r.easing)
    ) {
      for (const n in r.easing) U[n] = r.easing[n];
    }
    (yt = r.edgeStrategy || 'set'),
    (ct = { beforerender: r.beforerender, render: r.render, keyframe: r.keyframe }),
    (ft = r.forceHeight !== !1),
    ft && (Vt = r.scale || 1),
    (mt = r.mobileDeceleration || x),
    (dt = r.smoothScrolling !== !1),
    (gt = r.smoothScrollingDuration || E),
    (vt = { targetTop: it.getScrollTop() }),
    (Gt = (r.mobileCheck
        || function () {
          return /Android|iPhone|iPad|iPod|BlackBerry/i.test(
            navigator.userAgent || navigator.vendor || e.opera,
          );
        })()),
    Gt
      ? ((st = t.getElementById('skrollr-body')), st && at(), X(), Dt(o, [y, S], [T]))
      : Dt(o, [y, b], [T]),
    it.refresh(),
    St(e, 'resize orientationchange', () => {
      const e = o.clientWidth;
      const t = o.clientHeight;
      (t !== $t || e !== Mt) && (($t = t), (Mt = e), (_t = !0));
    });
    const i = Y();
    return (
      (function l() {
        Z(), (bt = i(l));
      }()),
      it
    );
  }
  let o;
  let a;
  const i = {
    get() {
      return it;
    },
    init(e) {
      return it || new n(e);
    },
    VERSION: '0.6.26',
  };
  const l = Object.prototype.hasOwnProperty;
  const s = e.Math;
  const c = e.getComputedStyle;
  const f = 'touchstart';
  const u = 'touchmove';
  const m = 'touchcancel';
  const p = 'touchend';
  const d = 'skrollable';
  const g = `${d}-before`;
  const v = `${d}-between`;
  const h = `${d}-after`;
  var y = 'skrollr';
  var T = `no-${y}`;
  var b = `${y}-desktop`;
  var S = `${y}-mobile`;
  const k = 'linear';
  const w = 1e3;
  var x = 0.004;
  var E = 200;
  const A = 'start';
  const F = 'end';
  const C = 'center';
  const D = 'bottom';
  const H = '___skrollable_id';
  const I = /^(?:input|textarea|button|select)$/i;
  const P = /^\s+|\s+$/g;
  const N = /^data(?:-(_\w+))?(?:-?(-?\d*\.?\d+p?))?(?:-?(start|end|top|center|bottom))?(?:-?(top|center|bottom))?$/;
  const O = /\s*(@?[\w\-\[\]]+)\s*:\s*(.+?)\s*(?:;|$)/gi;
  const V = /^(@?[a-z\-]+)\[(\w+)\]$/;
  const z = /-([a-z0-9_])/g;
  const q = function (e, t) {
    return t.toUpperCase();
  };
  const L = /[\-+]?[\d]*\.?[\d]+/g;
  const M = /\{\?\}/g;
  const $ = /rgba?\(\s*-?\d+\s*,\s*-?\d+\s*,\s*-?\d+/g;
  const _ = /[a-z\-]+-gradient/g;
  let B = '';
  let G = '';
  var K = function () {
    const e = /^(?:O|Moz|webkit|ms)|(?:-(?:o|moz|webkit|ms)-)/;
    if (c) {
      const t = c(a, null);
      for (const n in t) if ((B = n.match(e) || (+n == n && t[n].match(e)))) break;
      if (!B) return (B = G = ''), r;
      (B = B[0]),
      B.slice(0, 1) === '-'
        ? ((G = B),
        (B = {
          '-webkit-': 'webkit',
          '-moz-': 'Moz',
          '-ms-': 'ms',
          '-o-': 'O',
        }[B]))
        : (G = `-${B.toLowerCase()}-`);
    }
  };
  var Y = function () {
    let t = e.requestAnimationFrame || e[`${B.toLowerCase()}RequestAnimationFrame`];
    let r = Pt();
    return (
      (Gt || !t)
        && (t = function (t) {
          const n = Pt() - r;
          const o = s.max(0, 1e3 / 60 - n);
          return e.setTimeout(() => {
            (r = Pt()), t();
          }, o);
        }),
      t
    );
  };
  const R = function () {
    let t = e.cancelAnimationFrame || e[`${B.toLowerCase()}CancelAnimationFrame`];
    return (
      (Gt || !t)
        && (t = function (t) {
          return e.clearTimeout(t);
        }),
      t
    );
  };
  var U = {
    begin() {
      return 0;
    },
    end() {
      return 1;
    },
    linear(e) {
      return e;
    },
    quadratic(e) {
      return e * e;
    },
    cubic(e) {
      return e * e * e;
    },
    swing(e) {
      return -s.cos(e * s.PI) / 2 + 0.5;
    },
    sqrt(e) {
      return s.sqrt(e);
    },
    outCubic(e) {
      return s.pow(e - 1, 3) + 1;
    },
    bounce(e) {
      let t;
      if (e <= 0.5083) t = 3;
      else if (e <= 0.8489) t = 9;
      else if (e <= 0.96208) t = 27;
      else {
        if (!(e <= 0.99981)) return 1;
        t = 91;
      }
      return 1 - s.abs((3 * s.cos(1.028 * e * t)) / t);
    },
  };
  (n.prototype.refresh = function (e) {
    let n;
    let o;
    let a = !1;
    for (
      e === r
        ? ((a = !0), (lt = []), (Bt = 0), (e = t.getElementsByTagName('*')))
        : e.length === r && (e = [e]),
      n = 0,
      o = e.length;
      o > n;
      n++
    ) {
      const i = e[n];
      let l = i;
      const s = [];
      let c = dt;
      let f = yt;
      let u = !1;
      if ((a && H in i && delete i[H], i.attributes)) {
        for (let m = 0, p = i.attributes.length; p > m; m++) {
          const g = i.attributes[m];
          if (g.name !== 'data-anchor-target') {
            if (g.name !== 'data-smooth-scrolling') {
              if (g.name !== 'data-edge-strategy') {
                if (g.name !== 'data-emit-events') {
                  const v = g.name.match(N);
                  if (v !== null) {
                    const h = { props: g.value, element: i, eventType: g.name.replace(z, q) };
                    s.push(h);
                    const y = v[1];
                    y && (h.constant = y.substr(1));
                    const T = v[2];
                    /p$/.test(T)
                      ? ((h.isPercentage = !0), (h.offset = (0 | T.slice(0, -1)) / 100))
                      : (h.offset = 0 | T);
                    const b = v[3];
                    const S = v[4] || b;
                    b && b !== A && b !== F
                      ? ((h.mode = 'relative'), (h.anchors = [b, S]))
                      : ((h.mode = 'absolute'),
                      b === F ? (h.isEnd = !0) : h.isPercentage || (h.offset *= Vt));
                  }
                } else u = !0;
              } else f = g.value;
            } else c = g.value !== 'off';
          } else if (((l = t.querySelector(g.value)), l === null)) {
            throw `Unable to find anchor target "${g.value}"`;
          }
        }
        if (s.length) {
          var k;
          var w;
          var x;
          !a && H in i
            ? ((x = i[H]), (k = lt[x].styleAttr), (w = lt[x].classAttr))
            : ((x = i[H] = Bt++), (k = i.style.cssText), (w = Ct(i))),
          (lt[x] = {
            element: i,
            styleAttr: k,
            classAttr: w,
            anchorTarget: l,
            keyFrames: s,
            smoothScrolling: c,
            edgeStrategy: f,
            emitEvents: u,
            lastFrameIndex: -1,
          }),
          Dt(i, [d], []);
        }
      }
    }
    for (Et(), n = 0, o = e.length; o > n; n++) {
      const E = lt[e[n][H]];
      E !== r && (J(E), et(E));
    }
    return it;
  }),
  (n.prototype.relativeToAbsolute = function (e, t, r) {
    const n = o.clientHeight;
    const a = e.getBoundingClientRect();
    let i = a.top;
    const l = a.bottom - a.top;
    return (
      t === D ? (i -= n) : t === C && (i -= n / 2),
      r === D ? (i += l) : r === C && (i += l / 2),
      (i += it.getScrollTop()),
      0 | (i + 0.5)
    );
  }),
  (n.prototype.animateTo = function (e, t) {
    t = t || {};
    const n = Pt();
    const o = it.getScrollTop();
    return (
      (pt = {
        startTop: o,
        topDiff: e - o,
        targetTop: e,
        duration: t.duration || w,
        startTime: n,
        endTime: n + (t.duration || w),
        easing: U[t.easing || k],
        done: t.done,
      }),
      pt.topDiff || (pt.done && pt.done.call(it, !1), (pt = r)),
      it
    );
  }),
  (n.prototype.stopAnimateTo = function () {
    pt && pt.done && pt.done.call(it, !0), (pt = r);
  }),
  (n.prototype.isAnimatingTo = function () {
    return !!pt;
  }),
  (n.prototype.isMobile = function () {
    return Gt;
  }),
  (n.prototype.setScrollTop = function (t, r) {
    return (ht = r === !0), Gt ? (Kt = s.min(s.max(t, 0), Ot)) : e.scrollTo(0, t), it;
  }),
  (n.prototype.getScrollTop = function () {
    return Gt ? Kt : e.pageYOffset || o.scrollTop || a.scrollTop || 0;
  }),
  (n.prototype.getMaxScrollTop = function () {
    return Ot;
  }),
  (n.prototype.on = function (e, t) {
    return (ct[e] = t), it;
  }),
  (n.prototype.off = function (e) {
    return delete ct[e], it;
  }),
  (n.prototype.destroy = function () {
    const e = R();
    e(bt), wt(), Dt(o, [T], [y, b, S]);
    for (let t = 0, n = lt.length; n > t; t++) ot(lt[t].element);
    (o.style.overflow = a.style.overflow = ''),
    (o.style.height = a.style.height = ''),
    st && i.setStyle(st, 'transform', 'none'),
    (it = r),
    (st = r),
    (ct = r),
    (ft = r),
    (Ot = 0),
    (Vt = 1),
    (ut = r),
    (mt = r),
    (zt = 'down'),
    (qt = -1),
    (Mt = 0),
    ($t = 0),
    (_t = !1),
    (pt = r),
    (dt = r),
    (gt = r),
    (vt = r),
    (ht = r),
    (Bt = 0),
    (yt = r),
    (Gt = !1),
    (Kt = 0),
    (Tt = r);
  });
  var X = function () {
    let n;
    let i;
    let l;
    let c;
    let d;
    let g;
    let v;
    let h;
    let y;
    let T;
    let b;
    let S;
    St(o, [f, u, m, p].join(' '), (e) => {
      const o = e.changedTouches[0];
      for (c = e.target; c.nodeType === 3;) c = c.parentNode;
      switch (
        ((d = o.clientY),
        (g = o.clientX),
        (T = e.timeStamp),
        I.test(c.tagName) || e.preventDefault(),
        e.type)
      ) {
        case f:
          n && n.blur(), it.stopAnimateTo(), (n = c), (i = v = d), (l = g), (y = T);
          break;
        case u:
          I.test(c.tagName) && t.activeElement !== c && e.preventDefault(),
          (h = d - v),
          (S = T - b),
          it.setScrollTop(Kt - h, !0),
          (v = d),
          (b = T);
          break;
        default:
        case m:
        case p:
          var a = i - d;
          var k = l - g;
          var w = k * k + a * a;
          if (w < 49) {
            if (!I.test(n.tagName)) {
              n.focus();
              const x = t.createEvent('MouseEvents');
              x.initMouseEvent(
                'click',
                !0,
                !0,
                e.view,
                1,
                o.screenX,
                o.screenY,
                o.clientX,
                o.clientY,
                e.ctrlKey,
                e.altKey,
                e.shiftKey,
                e.metaKey,
                0,
                null,
              ),
              n.dispatchEvent(x);
            }
            return;
          }
          n = r;
          var E = h / S;
          E = s.max(s.min(E, 3), -3);
          var A = s.abs(E / mt);
          var F = E * A + 0.5 * mt * A * A;
          var C = it.getScrollTop() - F;
          var D = 0;
          C > Ot ? ((D = (Ot - C) / F), (C = Ot)) : C < 0 && ((D = -C / F), (C = 0)),
          (A *= 1 - D),
          it.animateTo(0 | (C + 0.5), { easing: 'outCubic', duration: A });
      }
    }),
    e.scrollTo(0, 0),
    (o.style.overflow = a.style.overflow = 'hidden');
  };
  const j = function () {
    let e;
    let t;
    let r;
    let n;
    let a;
    let i;
    let l;
    let c;
    let f;
    let u;
    let m;
    const p = o.clientHeight;
    const d = At();
    for (c = 0, f = lt.length; f > c; c++) {
      for (
        e = lt[c], t = e.element, r = e.anchorTarget, n = e.keyFrames, a = 0, i = n.length;
        i > a;
        a++
      ) {
        (l = n[a]),
        (u = l.offset),
        (m = d[l.constant] || 0),
        (l.frame = u),
        l.isPercentage && ((u *= p), (l.frame = u)),
        l.mode === 'relative'
            && (ot(t),
            (l.frame = it.relativeToAbsolute(r, l.anchors[0], l.anchors[1]) - u),
            ot(t, !0)),
        (l.frame += m),
        ft && !l.isEnd && l.frame > Ot && (Ot = l.frame);
      }
    }
    for (Ot = s.max(Ot, Ft()), c = 0, f = lt.length; f > c; c++) {
      for (e = lt[c], n = e.keyFrames, a = 0, i = n.length; i > a; a++) {
        (l = n[a]), (m = d[l.constant] || 0), l.isEnd && (l.frame = Ot - l.offset + m);
      }
      e.keyFrames.sort(Nt);
    }
  };
  const W = function (e, t) {
    for (let r = 0, n = lt.length; n > r; r++) {
      var o;
      var a;
      const s = lt[r];
      const c = s.element;
      let f = s.smoothScrolling ? e : t;
      const u = s.keyFrames;
      const m = u.length;
      const p = u[0];
      const y = u[u.length - 1];
      const T = p.frame > f;
      const b = f > y.frame;
      const S = T ? p : y;
      const k = s.emitEvents;
      const w = s.lastFrameIndex;
      if (T || b) {
        if ((T && s.edge === -1) || (b && s.edge === 1)) continue;
        switch (
          (T
            ? (Dt(c, [g], [h, v]), k && w > -1 && (xt(c, p.eventType, zt), (s.lastFrameIndex = -1)))
            : (Dt(c, [h], [g, v]), k && m > w && (xt(c, y.eventType, zt), (s.lastFrameIndex = m))),
          (s.edge = T ? -1 : 1),
          s.edgeStrategy)
        ) {
          case 'reset':
            ot(c);
            continue;
          case 'ease':
            f = S.frame;
            break;
          default:
          case 'set':
            var x = S.props;
            for (o in x) {
              l.call(x, o)
                && ((a = nt(x[o].value)),
                o.indexOf('@') === 0 ? c.setAttribute(o.substr(1), a) : i.setStyle(c, o, a));
            }
            continue;
        }
      } else s.edge !== 0 && (Dt(c, [d, v], [g, h]), (s.edge = 0));
      for (let E = 0; m - 1 > E; E++) {
        if (f >= u[E].frame && u[E + 1].frame >= f) {
          const A = u[E];
          const F = u[E + 1];
          for (o in A.props) {
            if (l.call(A.props, o)) {
              let C = (f - A.frame) / (F.frame - A.frame);
              (C = A.props[o].easing(C)),
              (a = rt(A.props[o].value, F.props[o].value, C)),
              (a = nt(a)),
              o.indexOf('@') === 0 ? c.setAttribute(o.substr(1), a) : i.setStyle(c, o, a);
            }
          }
          k
            && w !== E
            && (zt === 'down' ? xt(c, A.eventType, zt) : xt(c, F.eventType, zt),
            (s.lastFrameIndex = E));
          break;
        }
      }
    }
  };
  var Z = function () {
    _t && ((_t = !1), Et());
    let e;
    let t;
    let n = it.getScrollTop();
    const o = Pt();
    if (pt) {
      o >= pt.endTime
        ? ((n = pt.targetTop), (e = pt.done), (pt = r))
        : ((t = pt.easing((o - pt.startTime) / pt.duration)),
        (n = 0 | (pt.startTop + t * pt.topDiff))),
      it.setScrollTop(n, !0);
    } else if (!ht) {
      const a = vt.targetTop - n;
      a
        && (vt = {
          startTop: qt,
          topDiff: n - qt,
          targetTop: n,
          startTime: Lt,
          endTime: Lt + gt,
        }),
      vt.endTime >= o
          && ((t = U.sqrt((o - vt.startTime) / gt)), (n = 0 | (vt.startTop + t * vt.topDiff)));
    }
    if ((Gt && st && i.setStyle(st, 'transform', `translate(0, ${-Kt}px) ${Tt}`), ht || qt !== n)) {
      (zt = n > qt ? 'down' : qt > n ? 'up' : zt), (ht = !1);
      const l = {
        curTop: n,
        lastTop: qt,
        maxTop: Ot,
        direction: zt,
      };
      const s = ct.beforerender && ct.beforerender.call(it, l);
      s !== !1 && (W(n, it.getScrollTop()), (qt = n), ct.render && ct.render.call(it, l)),
      e && e.call(it, !1);
    }
    Lt = o;
  };
  var J = function (e) {
    for (let t = 0, r = e.keyFrames.length; r > t; t++) {
      for (var n, o, a, i, l = e.keyFrames[t], s = {}; (i = O.exec(l.props)) !== null;) {
        (a = i[1]),
        (o = i[2]),
        (n = a.match(V)),
        n !== null ? ((a = n[1]), (n = n[2])) : (n = k),
        (o = o.indexOf('!') ? Q(o) : [o.slice(1)]),
        (s[a] = { value: o, easing: U[n] });
      }
      l.props = s;
    }
  };
  var Q = function (e) {
    const t = [];
    return (
      ($.lastIndex = 0),
      (e = e.replace($, e => e.replace(L, e => `${100 * (e / 255)}%`))),
      G && ((_.lastIndex = 0), (e = e.replace(_, e => G + e))),
      (e = e.replace(L, e => (t.push(+e), '{?}'))),
      t.unshift(e),
      t
    );
  };
  var et = function (e) {
    let t;
    let r;
    let n = {};
    for (t = 0, r = e.keyFrames.length; r > t; t++) tt(e.keyFrames[t], n);
    for (n = {}, t = e.keyFrames.length - 1; t >= 0; t--) tt(e.keyFrames[t], n);
  };
  var tt = function (e, t) {
    let r;
    for (r in t) l.call(e.props, r) || (e.props[r] = t[r]);
    for (r in e.props) t[r] = e.props[r];
  };
  var rt = function (e, t, r) {
    let n;
    const o = e.length;
    if (o !== t.length) throw `Can't interpolate between "${e[0]}" and "${t[0]}"`;
    const a = [e[0]];
    for (n = 1; o > n; n++) a[n] = e[n] + (t[n] - e[n]) * r;
    return a;
  };
  var nt = function (e) {
    let t = 1;
    return (M.lastIndex = 0), e[0].replace(M, () => e[t++]);
  };
  var ot = function (e, t) {
    e = [].concat(e);
    for (var r, n, o = 0, a = e.length; a > o; o++) {
      (n = e[o]),
      (r = lt[n[H]]),
      r
          && (t
            ? ((n.style.cssText = r.dirtyStyleAttr), Dt(n, r.dirtyClassAttr))
            : ((r.dirtyStyleAttr = n.style.cssText),
            (r.dirtyClassAttr = Ct(n)),
            (n.style.cssText = r.styleAttr),
            Dt(n, r.classAttr)));
    }
  };
  var at = function () {
    (Tt = 'translateZ(0)'), i.setStyle(st, 'transform', Tt);
    const e = c(st);
    const t = e.getPropertyValue('transform');
    const r = e.getPropertyValue(`${G}transform`);
    const n = (t && t !== 'none') || (r && r !== 'none');
    n || (Tt = '');
  };
  i.setStyle = function (e, t, r) {
    const n = e.style;
    if (((t = t.replace(z, q).replace('-', '')), t === 'zIndex')) {
      n[t] = isNaN(r) ? r : `${0 | r}`;
    } else if (t === 'float') n.styleFloat = n.cssFloat = r;
    else {
      try {
        B && (n[B + t.slice(0, 1).toUpperCase() + t.slice(1)] = r), (n[t] = r);
      } catch (o) {}
    }
  };
  let it;
  let lt;
  let st;
  let ct;
  let ft;
  let ut;
  let mt;
  let pt;
  let dt;
  let gt;
  let vt;
  let ht;
  let yt;
  let Tt;
  let bt;
  var St = (i.addEvent = function (t, r, n) {
    const o = function (t) {
      return (
        (t = t || e.event),
        t.target || (t.target = t.srcElement),
        t.preventDefault
          || (t.preventDefault = function () {
            (t.returnValue = !1), (t.defaultPrevented = !0);
          }),
        n.call(this, t)
      );
    };
    r = r.split(' ');
    for (var a, i = 0, l = r.length; l > i; i++) {
      (a = r[i]),
      t.addEventListener ? t.addEventListener(a, n, !1) : t.attachEvent(`on${a}`, o),
      Yt.push({ element: t, name: a, listener: n });
    }
  });
  const kt = (i.removeEvent = function (e, t, r) {
    t = t.split(' ');
    for (let n = 0, o = t.length; o > n; n++) {
      e.removeEventListener ? e.removeEventListener(t[n], r, !1) : e.detachEvent(`on${t[n]}`, r);
    }
  });
  var wt = function () {
    for (var e, t = 0, r = Yt.length; r > t; t++) (e = Yt[t]), kt(e.element, e.name, e.listener);
    Yt = [];
  };
  var xt = function (e, t, r) {
    ct.keyframe && ct.keyframe.call(it, e, t, r);
  };
  var Et = function () {
    const e = it.getScrollTop();
    (Ot = 0),
    ft && !Gt && (a.style.height = ''),
    j(),
    ft && !Gt && (a.style.height = `${Ot + o.clientHeight}px`),
    Gt ? it.setScrollTop(s.min(it.getScrollTop(), Ot)) : it.setScrollTop(e, !0),
    (ht = !0);
  };
  var At = function () {
    let e;
    let t;
    const r = o.clientHeight;
    const n = {};
    for (e in ut) {
      (t = ut[e]),
      typeof t === 'function'
        ? (t = t.call(it))
        : /p$/.test(t) && (t = (t.slice(0, -1) / 100) * r),
      (n[e] = t);
    }
    return n;
  };
  var Ft = function () {
    const e = (st && st.offsetHeight) || 0;
    const t = s.max(
      e,
      a.scrollHeight,
      a.offsetHeight,
      o.scrollHeight,
      o.offsetHeight,
      o.clientHeight,
    );
    return t - o.clientHeight;
  };
  var Ct = function (t) {
    let r = 'className';
    return e.SVGElement && t instanceof e.SVGElement && ((t = t[r]), (r = 'baseVal')), t[r];
  };
  var Dt = function (t, n, o) {
    let a = 'className';
    if ((e.SVGElement && t instanceof e.SVGElement && ((t = t[a]), (a = 'baseVal')), o === r)) {
      return (t[a] = n), r;
    }
    for (var i = t[a], l = 0, s = o.length; s > l; l++) i = It(i).replace(It(o[l]), ' ');
    i = Ht(i);
    for (let c = 0, f = n.length; f > c; c++) It(i).indexOf(It(n[c])) === -1 && (i += ` ${n[c]}`);
    t[a] = Ht(i);
  };
  var Ht = function (e) {
    return e.replace(P, '');
  };
  var It = function (e) {
    return ` ${e} `;
  };
  var Pt = Date.now
    || function () {
      return +new Date();
    };
  var Nt = function (e, t) {
    return e.frame - t.frame;
  };
  var Ot = 0;
  var Vt = 1;
  var zt = 'down';
  var qt = -1;
  var Lt = Pt();
  var Mt = 0;
  var $t = 0;
  var _t = !1;
  var Bt = 0;
  var Gt = !1;
  var Kt = 0;
  var Yt = [];
  typeof define === 'function' && define.amd
    ? define('skrollr', () => i)
    : typeof module !== 'undefined' && module.exports
      ? (module.exports = i)
      : (e.skrollr = i);
}(window, document));
